<!-- eslint-disable -->
<template lang="pug">
    .todo-banner
        .todo-banner__header
            | {{ $i18n.t('dashboard.dashboard_toDo_header') }}
        divider.todo-banner__divider(:margin="'0 auto'")
        template(v-if="!isLoading")
            .todo-banner__body
                template(v-if="tasks.length > 0")
                    div(v-for="(task, index) in tasks")
                        .task
                            cs-checkbox.task__checkbox(v-model="task.isDone", @click="update(task, index)")
                            .task__container(@click.prevent="removeTask(task, index)")
                                .task__description(
                                    :class="{'task__description--done': task.isDone, 'task__description--important': task.isImportant}"
                                ) {{ task.description }}
                                svg-icon.task__icon(name="cancel" size="x-large")
                        divider(:margin="'0 auto'" :not-show-last-child="true")
                .todo-banner__empty(v-else)
                    | {{ $i18n.t('dashboard.dashboard_toDo_empty') }}
            .todo-banner__footer
                form(action="javascript://" @submit="addTask")
                    cs-input.todo-banner__task-input(
                        type="text"
                        v-model.trim="newTask"
                        :placeholder="$i18n.t('dashboard.dashboard_toDo_formPlaceholder')"
                    )
                    .todo-banner__buttons
                        cs-button.todo-banner__button(color="blue")
                            | {{ $i18n.t('dashboard.dashboard_toDo_addTask') }}
                        cs-checkbox.todo-banner__button(v-model="important", @click="update(task, index)")
                            | {{ $i18n.t('dashboard.dashboard_toDo_important') }}
        cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import TaskApi from '../../../api/user/task'
    export default {
        data() {
            return {
                newTask: '',
                important: false,
                tasks: [],
                isLoading: false,
                isLoadingTask: false,
                isLoadingDelete: false,
            }
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                TaskApi.list()
                .then((data) => {
                    this.tasks = data.tasks.map(task => {
                        task.isDone = !!task.isDone;
                        return task
                    });
                    this.isLoading = false;
                })
            },
            addTask() {
                if (this.newTask === '') {
                    return;
                }
                this.isLoadingTask = true;
                let task = {
                    description: this.newTask,
                    isDone: false,
                    isImportant: this.important
                };
                TaskApi.create(task)
                .then((data) => {
                    this.tasks.push(data);
                    this.isLoadingTask = false;
                })
                .catch(() => {
                    this.isLoadingTask = false;
                });
                this.newTask = '';
            },
            removeTask(task, index) {
                if (!this.isLoadingDelete) {
                    this.isLoadingDelete = true;
                    TaskApi.delete(task.id, task)
                    .then((data) => {
                        if (data.status === 'ok') {
                            this.tasks.splice(index, 1);
                        }
                        this.isLoadingDelete = false;
                    })
                    .catch(() => {
                        this.isLoadingDelete = false;
                    })
                }
            },
            update(task, index) {
                this.$nextTick(() => {
                    TaskApi.update(task.id, task)
                    .then((data) => {
                        this.$set(this.tasks, index, data);
                    })
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .todo-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .todo-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .todo-banner__body {
        margin: 0 30px;
        font-size: 16px;
        line-height: 24px;
    }

    .todo-banner__footer {
        margin: 0 30px 30px;
    }

    .todo-banner__task-input {
        padding: 15px 15px 25px 15px;
        margin-bottom: 10px;
    }

    .todo-banner__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap-reverse;
    }

    .todo-banner__button {
        margin-top: 10px;
        margin-bottom: 10px !important;
    }

    .todo-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .todo-banner__empty {
        margin: 20px 0;
        font-size: 16px;
        line-height: 19px;
    }

    .todo-banner__empty-icon {
        color: $hsl-color-gray-74;
        font-size: 30px;
        padding-bottom: 10px;
    }

    .task {
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .task__checkbox {
        margin-bottom: 0;
    }

    .task__icon {
        color: $hsl-color-gray-74;
    }

    .task__container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover {
            .task__icon {
                color: $hsl-color-red-62;
            }
        }
    }

    .task__description {
        font-size: 16px;
        line-height: 19px;
        color: $hsl-color-blue-56;

        text-decoration-line: underline;
    }

    .task__description--done {
        text-decoration: line-through;
    }

    .todo-banner__checkbox {
        margin-bottom: 20px;
    }

    .task__description--important {
        color: $x-color-orange;
    }

    .task__description--important::before {
        content: '🔥';
        display: inline-block;
        margin-right: 5px;
    }
</style>
